import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {LoadBalanceConfiguration} from './types'

export const buildLoadBalanceConfiguration = (
  input: BuildConfigurationInput
): LoadBalanceConfiguration => {
  const constraints = input.options.constraints.loadBalance
  if (!constraints?.isEnabled) {
    return {loadBalance: {isEnabled: false}}
  }
  return {
    loadBalance: {
      isEnabled: true,
      eligibleQuantityRange: constraints?.eligibleQuantityRange,
      maxTruckSize: constraints?.maxTruckSize
    }
  }
}
